function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
import { buildComponentName } from '../utils';
var __vue_script__ = {
  name: buildComponentName('Badge'),
  props: {
    prefixCls: {
      type: String,
      default: 'ux-badge'
    },
    scrollNumberPrefixCls: {
      type: String,
      default: 'ux-scroll-number'
    },
    count: [Number, String],
    showZero: Boolean,
    overflowCount: {
      type: [Number, String],
      default: 99
    },
    dot: Boolean,
    customStyle: Object,
    status: {
      type: String,
      validator: function validator(val) {
        return ['success', 'processing', 'default', 'error', 'warning'].indexOf(val) !== -1;
      }
    },
    text: String,
    theme: {
      type: String,
      default: 'light'
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    isDot: function isDot() {
      var dot = this.dot,
          status = this.status;
      return dot || status;
    },
    displayCount: function displayCount() {
      var count = this.count,
          overflowCount = this.overflowCount,
          isDot = this.isDot;
      var _ref = [Number(count), Number(overflowCount)],
          nCnt = _ref[0],
          nOfCnt = _ref[1];

      if (isDot || Number.isNaN(nCnt) || Number.isNaN(nOfCnt)) {
        return '';
      }

      return nCnt > nOfCnt ? "".concat(nOfCnt, "+") : nCnt;
    },
    isZero: function isZero() {
      var displayCount = this.displayCount;
      return displayCount === 0;
    },
    isHidden: function isHidden() {
      var isZero = this.isZero,
          showZero = this.showZero,
          isDot = this.isDot,
          displayCount = this.displayCount;
      return !isDot && (isZero && !showZero || displayCount === '');
    },
    statusClasses: function statusClasses() {
      var _ref2;

      var prefixCls = this.prefixCls,
          status = this.status;
      return _ref2 = {}, _defineProperty(_ref2, "".concat(prefixCls, "-status-dot"), status), _defineProperty(_ref2, "".concat(prefixCls, "-status-").concat(status), status), _ref2;
    },
    scrollNumberClasses: function scrollNumberClasses() {
      var _ref3;

      var prefixCls = this.prefixCls,
          scrollNumberPrefixCls = this.scrollNumberPrefixCls,
          isDot = this.isDot,
          displayCount = this.displayCount,
          status = this.status;
      return _ref3 = {}, _defineProperty(_ref3, "".concat(scrollNumberPrefixCls), true), _defineProperty(_ref3, "".concat(prefixCls, "-dot"), isDot), _defineProperty(_ref3, "".concat(prefixCls, "-count"), !isDot), _defineProperty(_ref3, "".concat(prefixCls, "-multiple-words"), String(displayCount).length > 1), _defineProperty(_ref3, "".concat(prefixCls, "-status-").concat(status), status), _ref3;
    },
    badgeClasses: function badgeClasses() {
      var _ref4;

      var prefixCls = this.prefixCls,
          status = this.status,
          theme = this.theme;
      return _ref4 = {}, _defineProperty(_ref4, prefixCls, true), _defineProperty(_ref4, "".concat(prefixCls, "-").concat(theme), true), _defineProperty(_ref4, "".concat(prefixCls, "-status"), status), _ref4;
    }
  },
  render: function render(h) {
    var prefixCls = this.prefixCls,
        status = this.status,
        statusClasses = this.statusClasses,
        badgeClasses = this.badgeClasses,
        customStyle = this.customStyle,
        displayCount = this.displayCount,
        isHidden = this.isHidden,
        $slots = this.$slots,
        text = this.text,
        scrollNumberPrefixCls = this.scrollNumberPrefixCls,
        scrollNumberClasses = this.scrollNumberClasses;
    var _$slots$default = $slots.default,
        slotDefault = _$slots$default === void 0 ? [] : _$slots$default;
    var hasSlotDefault = slotDefault.length > 0;
    var textContent = h('span', {
      class: "".concat(prefixCls, "-status-text")
    }, text);

    if (!hasSlotDefault && status) {
      return h('span', {
        class: badgeClasses,
        style: customStyle
      }, [h('span', {
        class: statusClasses
      }), textContent]);
    }

    var subItems = [];

    if (!isHidden) {
      var scrollNumber = h('sup', {
        class: _objectSpread({}, scrollNumberClasses),
        style: customStyle
      }, [h('span', {
        class: _defineProperty({}, "".concat(scrollNumberPrefixCls, "-only"), true)
      }, [displayCount])]);
      var item = [scrollNumber];

      if (hasSlotDefault) {
        item = h('transition', {
          attrs: {
            name: "".concat(prefixCls, "-zoom")
          },
          props: {
            appear: true
          }
        }, [scrollNumber]);
      }

      subItems.push(item);

      if (text) {
        subItems.push(textContent);
      }
    }

    return h('span', {
      class: [badgeClasses, _defineProperty({}, "".concat(prefixCls, "-not-a-wrapper"), !hasSlotDefault)]
    }, [slotDefault].concat(subItems));
  }
};
/* template */

/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = undefined;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "badge.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  if (false) {
    var hook;

    if (false) {
      // In SSR.
      hook = function hook(context) {
        // 2.3 injection
        context = context || // cached call
        this.$vnode && this.$vnode.ssrContext || // stateful
        this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
        // 2.2 with runInNewContext: true

        if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
          context = __VUE_SSR_CONTEXT__;
        } // inject component styles


        if (style) {
          style.call(this, createInjectorSSR(context));
        } // register component module identifier for async chunk inference


        if (context && context._registeredComponents) {
          context._registeredComponents.add(moduleIdentifier);
        }
      }; // used by ssr in case component is cached and beforeCreate
      // never gets called


      component._ssrRegister = hook;
    } else if (style) {
      hook = shadowMode ? function (context) {
        style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
      } : function (context) {
        style.call(this, createInjector(context));
      };
    }

    if (hook !== undefined) {
      if (component.functional) {
        // register for functional component in vue file
        var originalRender = component.render;

        component.render = function renderWithStyleInjection(h, context) {
          hook.call(context);
          return originalRender(h, context);
        };
      } else {
        // inject component registration as beforeCreate hook
        var existing = component.beforeCreate;
        component.beforeCreate = existing ? [].concat(existing, hook) : [hook];
      }
    }
  }

  return component;
}
/* style inject */

/* style inject SSR */

/* style inject shadow dom */


var __vue_component__ = __vue_normalize__({}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

export default __vue_component__;